module.exports = __webpack_public_path__ + "static/9csm_ACO_LipuSmart_Hero-164f9419c493f13d432fee8c185ff809.jpg";